module.exports = __webpack_public_path__ + "static/communautes-db67bcd98e08b1c6ae74f9546d28833d.png";